import { createContext } from 'react';

export const EditPayoutProfileDrawerContext = createContext(null);
